/** @jsxRuntime classic */
// @ts-check
/** @jsx jsx */
import { gql } from '@apollo/client';
import { AwardIcon, P, Text } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function ProductAwards({ product, ...rest }) {
  if (!product?.awards?.length) return null;
  return (
    <Section title={<Trans>Awards</Trans>} {...rest}>
      {product.awards.map((award) => (
        <P key={award.award}>
          <AwardIcon sx={{ marginRight: 2 }} />
          {award.medal && (
            <Text as="span" variant="semiTitle" sx={{ marginRight: 2 }}>
              {award.medal}{' '}
            </Text>
          )}
          {award.award}
        </P>
      ))}
    </Section>
  );
}

export const fragment = graphql`
  fragment ProductAwards on Product {
    productId
    awards {
      award
      medal
    }
  }
`;

ProductAwards.fragment = gql`
  fragment ProductAwards on Product {
    productId
    awards {
      award
      medal
    }
  }
`;
